export enum BusinessType {
    Buyer = 'buyer',
    Seller = 'seller',
}
